import { FC } from 'react';

import { IModifierTypeUIProps } from 'features/menu/components/product-detail/modifier/types';
import {
  getSelectedMultiplier,
  logProductModifierCustomization,
} from 'features/menu/components/product-detail/modifier/utils';

import { ModifierListItem } from './modifier-list-item';

export const ModifierCheckbox: FC<IModifierTypeUIProps> = ({
  modifier,
  selections,
  onSelectionsChange,
}) => {
  const selectedMultiplier = getSelectedMultiplier(modifier, selections);
  const isSelected = selectedMultiplier.multiplier === 1;

  const onCardPress = () => {
    const isSelected = selectedMultiplier.multiplier === 1;

    const userSelection = modifier.multipliers.find(modifier =>
      isSelected ? modifier.multiplier === 0 : modifier.multiplier === 1
    );

    if (!userSelection) {
      return;
    }

    onSelectionsChange({ [userSelection.id]: 1 });
    logProductModifierCustomization(userSelection.name, modifier.name, userSelection.id);
  };

  return (
    <ModifierListItem
      onCardPress={onCardPress}
      isSelected={isSelected}
      content={modifier}
      itemValue={selectedMultiplier}
    />
  );
};
